export default "__VITE_ASSET__CZRUq1h0__"